import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, MapPinIcon } from 'lucide-react';
const purchases = [{
  name: 'Carolina M.',
  location: 'Buenos Aires',
  time: 'hace 3 min',
  product: 'Megapack + Nutripro Plus'
}, {
  name: 'Valentina R.',
  location: 'CABA',
  time: 'hace 5 min',
  product: 'Megapack Nutripro Listo'
}, {
  name: 'Lucía G.',
  location: 'Buenos Aires',
  time: 'hace 8 min',
  product: 'Megapack + Nutripro Plus'
}, {
  name: 'Florencia D.',
  location: 'La Plata, BA',
  time: 'hace 12 min',
  product: 'Megapack + Nutripro Plus'
}, {
  name: 'Camila S.',
  location: 'Buenos Aires',
  time: 'hace 15 min',
  product: 'Megapack Nutripro Listo'
}, {
  name: 'Agustina P.',
  location: 'CABA',
  time: 'hace 18 min',
  product: 'Megapack + Nutripro Plus'
}, {
  name: 'María José L.',
  location: 'Buenos Aires',
  time: 'hace 22 min',
  product: 'Megapack + Nutripro Plus'
}, {
  name: 'Daniela F.',
  location: 'Quilmes, BA',
  time: 'hace 25 min',
  product: 'Megapack Nutripro Listo'
}, {
  name: 'Rocío T.',
  location: 'Buenos Aires',
  time: 'hace 30 min',
  product: 'Megapack + Nutripro Plus'
}, {
  name: 'Paula V.',
  location: 'CABA',
  time: 'hace 35 min',
  product: 'Megapack + Nutripro Plus'
}, {
  name: 'Julieta A.',
  location: 'San Isidro, BA',
  time: 'hace 40 min',
  product: 'Megapack Nutripro Listo'
}, {
  name: 'Milagros K.',
  location: 'Buenos Aires',
  time: 'hace 45 min',
  product: 'Megapack + Nutripro Plus'
}];
export function RecentPurchases() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    // Show first popup after 6 seconds
    const initialDelay = setTimeout(() => {
      setVisible(true);
    }, 6000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 4 seconds, then show next after 8 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 4000);
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setVisible(true);
    }, 12000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [visible, currentIndex]);
  const purchase = purchases[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs" data-id="element-247">
      <AnimatePresence data-id="element-248">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="bg-surface border border-mint/20 rounded-xl p-4 shadow-2xl shadow-black/40 backdrop-blur-sm" data-id="element-249">
            <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-white/30 hover:text-white/60 transition-colors text-xs leading-none p-1" aria-label="Cerrar" data-id="element-250">
              ✕
            </button>

            <div className="flex items-start gap-3" data-id="element-251">
              <div className="w-10 h-10 rounded-full bg-mint/20 flex items-center justify-center shrink-0" data-id="element-252">
                <ShoppingBagIcon size={18} className="text-mint" data-id="element-253" />
              </div>
              <div className="min-w-0" data-id="element-254">
                <p className="text-white text-sm font-bold leading-tight" data-id="element-255">
                  {purchase.name}
                </p>
                <p className="text-mint text-xs font-medium mt-0.5" data-id="element-256">
                  compró {purchase.product}
                </p>
                <div className="flex items-center gap-1.5 mt-1.5" data-id="element-257">
                  <MapPinIcon size={12} className="text-white/40 shrink-0" data-id="element-258" />
                  <span className="text-white/40 text-xs" data-id="element-259">
                    {purchase.location} · {purchase.time}
                  </span>
                </div>
              </div>
            </div>

            <div className="mt-2 flex items-center gap-1.5" data-id="element-260">
              <span className="w-1.5 h-1.5 bg-mint rounded-full animate-pulse" data-id="element-261" />
              <span className="text-white/30 text-[10px] font-medium uppercase tracking-wider" data-id="element-262">
                Compra verificada
              </span>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}